import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderExchangeManagementContainer from '../../containers/order/OrderExchangeManagementContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderExchangeManagement = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_EXCHANGE_MANAGEMENT}>
      <OrderExchangeManagementContainer />
    </PageTemplate>
  );
};

export default OrderExchangeManagement;
